<template>
  <div class="flex flex-col">
    <div class="flex w-full flex-col items-start gap-4">
      <div class="flex w-full flex-col gap-0.5">
        <h3 class="text-title-medium">Skills</h3>
        <MenonChart
          :skill-analysis="allSkills"
          :max-value="analysis.scale.items.length"
          :topic-perspectives="topicPerspectives"
          :fix-width="300"
          background-color="surface-container-lowest"
        />
      </div>
      <div class="flex flex-col gap-2">
        <h3 class="text-title-medium">Fragen</h3>
        <div class="grid w-full grid-cols-2 gap-4">
          <PrintQuestion
            v-for="question in allQuestions"
            :key="question.question.id"
            class="grow basis-0"
            :question="question"
            :topic-perspectives="topicPerspectives"
            :labels="question.labels"
            :title="$t('dialog.evaluation.slide.strengths')"
          />
        </div>
      </div>
      <div class="flex w-full grow flex-col gap-4 lg:flex-row">
        <PrintFinalTextFeedbacks class="grow basis-0" :texts="analysis.texts" />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import { computed } from 'vue'
  import MenonChart from '@/core/components/analytics/menon-chart/MenonChart.vue'
  import type { EvaluationAnalysis } from '@/core/models/surveys-analytics'
  import type { Perspective } from '@/core/models/perspective'
  import { perspectivesFromTopic } from '@/core/models/perspective'
  import { useSkillAnalysis } from '@/core/composables/use-skill-analysis'
  import PrintFinalTextFeedbacks from '@/modules/dialog/components/print/PrintFinalTextFeedbacks.vue'
  import PrintQuestion from './PrintQuestion.vue'
  import { useQuestionAnalysisNew } from '@/core/composables/use-question-analysis-new'
  interface Props {
    feedbackTopic: {
      id: string
      title: string
      icon: string
      showBlindspots: boolean
      perspectives: ReadonlyArray<Perspective>
      includeSelf: boolean
    }
    analysis: EvaluationAnalysis
  }

  const props = defineProps<Props>()
  const { allSkills } = useSkillAnalysis(props.analysis.skills)
  const topicPerspectives = computed(() => perspectivesFromTopic(props.feedbackTopic))

  const { allQuestions, mainFilter } = useQuestionAnalysisNew(
    props.analysis.questions,
    props.feedbackTopic.showBlindspots,
  )
  mainFilter.value = 'all'
</script>
